/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var FilterFillIcon = function FilterFillIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12.3334L19.7563 7.53644C21.1933 6.33891 20.3465 4 18.4759 4H5.52413C3.65353 4 2.80673 6.33892 4.24376 7.53644L10 12.3333V17.5L14 21V12.3334Z"
  }));
};
export default FilterFillIcon;